import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    name: 'findShip1',
    component: function () {
      return import(/* webpackChunkName: "findShip" */ '../views/FindShipView.vue')
    }
  },
  {
    path: '/doc-preview',
    name: 'DocPreview',
    component: function () {
      return import(/* webpackChunkName: "findShip" */ '../views/previewDoc.vue')
    }
  },
  {
    path: '/uploadDeviceFile',
    name: 'UploadDeviceFile',
    component: function () {
      return import(/* webpackChunkName: "uploadDeviceFile" */ '../views/UploadDeviceFile.vue')
    }
  }
  // ,{
  //   path: '/findShip',
  //   name: 'findShip',
  //   // component: FindShipView
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: function () {
  //     return import(/* webpackChunkName: "findShip" */ '../views/FindShipView.vue')
  //   }
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
